import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        component: () => import("@/page/Malangtalk/Index"),
        meta: {
            title: "마이 랭귀지 튜터 - malang talk (말랑톡)",
            metaTags: [
                {
                    name: "description",
                    content:
                        "영어, 난 쫄지 않아! 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요. 나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!",
                },
                { property: "robots", content: "index,follow" },
                { property: "og:title", content: "마이 랭귀지 튜터, malang talk (말랑톡)" },
                { property: "og:site_name", content: "말랑톡" },
                { property: "og:type", content: "website" },
                { property: "og:url", content: "https://malangtalk.com" },
                {
                    property: "og:image",
                    content: "https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png",
                },
                {
                    property: "og:description",
                    content:
                        "영어, 난 쫄지 않아! 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요. 나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!",
                },
                { itemprop: "name", content: "마이 랭귀지 튜터, malang talk (말랑톡)" },
                {
                    itemprop: "description",
                    content:
                        "영어, 난 쫄지 않아! 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요. 나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!",
                },
                {
                    itemprop: "image",
                    content: "https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png",
                },
                // 추가 메타 태그는 여기에
            ],
        },
    },
    {
        path: "/index",
        component: () => import("@/page/Malangtalk/Index"),
        meta: {
            title: "마이 랭귀지 튜터 - malang talk (말랑톡)",
            metaTags: [
                {
                    name: "description",
                    content:
                        "영어, 난 쫄지 않아! 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요. 나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!",
                },
                { property: "robots", content: "index,follow" },
                { property: "og:title", content: "마이 랭귀지 튜터, malang talk (말랑톡)" },
                { property: "og:site_name", content: "말랑톡" },
                { property: "og:type", content: "website" },
                { property: "og:url", content: "https://malangtalk.com" },
                {
                    property: "og:image",
                    content: "https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png",
                },
                {
                    property: "og:description",
                    content:
                        "영어, 난 쫄지 않아! 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요. 나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!",
                },
                { itemprop: "name", content: "마이 랭귀지 튜터, malang talk (말랑톡)" },
                {
                    itemprop: "description",
                    content:
                        "영어, 난 쫄지 않아! 상황별 영어 대화에서 나만의 맞춤 대화까지! 의사소통 중심의 학습법으로 진짜 스피킹 실력을 키워보세요. 나만의 맞춤 피드백과 월별 분석 리포트로 완벽개선까지! 한 번에!",
                },
                {
                    itemprop: "image",
                    content: "https://kr.object.ncloudstorage.com/aitutor-plus/logo/logo_default.png",
                },
                // 추가 메타 태그는 여기에
            ],
        },
    },
    {
        path: "/PrivacyPolicy",
        component: () => import("@/page/Malangtalk/PrivacyPolicy"),
        meta: {
            title: "개인정보처리방침",
        },
    },
    {
        path: "/TermsOfUse",
        component: () => import("@/page/Malangtalk/TermsOfUse"),
        meta: {
            title: "이용약관",
        },
    },
]
const malangtalk = new VueRouter({
    mode: "history",
    routes,
})

export default malangtalk
